import {
    FETCH_EVT,
    FETCH_EVTS,
    STORE_EVTS_COLUMNS,
    REPLACE_EVT_IN_EVTS,
    WX_LEVEL_SHARE_ATTENDEES ,
    FETCH_OPERTION_EVT,
    FETCHLEVELSHARE,
    FETCHLEVELSHARETWO,
    FETCH_WXLEVELSHARESTATIS,
    FETCH_CHECKINCREDIT,
    FETCH_CODESHARES,
    FETCH_GUESTGROUPS,
    FETCH_EVENTGROUPS,
    FETCH_EVENTCOMMENTPAGES,
    FETCH_EVENTCOMMENTS
} from '../actions/evt';
import {regroupTree} from '../../utils/index'



export const initialState = {
    isFetching: true,
    data: null
};

export const evts = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        case STORE_EVTS_COLUMNS:
            return Object.assign({}, state, {
                extra: {
                    columns: action.columns
                }
            });
        case REPLACE_EVT_IN_EVTS:
            if (!state.data || !Array.isArray(state.data) || !action.evt || !action.evt.data) {
                return Object.assign({}, state, {});
            }
            const replactedData = state.data.map((evt, index) => {
                return evt.header.id == action.evtId ? action.evt.data : evt;
            })

            return Object.assign({}, state, {data: replactedData});

        default:
            return state;
    }
}

export const opertionEvts = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_OPERTION_EVT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_OPERTION_EVT}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const levelShares = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCHLEVELSHARE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCHLEVELSHARE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const twoLevelShares = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCHLEVELSHARETWO}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCHLEVELSHARETWO}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const wxLevelShareStatis = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_WXLEVELSHARESTATIS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_WXLEVELSHARESTATIS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data.infoList,
            });
        default:
            return state;
    }
}
export const wxLevelShareAttendees = (state = initialState, action) => {
    switch (action.type) {
        case `WX_LEVEL_SHARE_ATTENDEES`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data,
            });
        default:
            return state;
    }
}
export const checkinCredits = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CHECKINCREDIT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CHECKINCREDIT}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const codeShares = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CODESHARES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CODESHARES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const guestGroups = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_GUESTGROUPS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_GUESTGROUPS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const eventGroups = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVENTGROUPS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVENTGROUPS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const eventCommentPages = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVENTCOMMENTPAGES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVENTCOMMENTPAGES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data.map(obj=>{
                    delete obj.children;
                    return obj;
                }),
            });
        default:
            return state;
    }
}
export const eventComments = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVENTCOMMENTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVENTCOMMENTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data:regroupTree(action.payload.data),
            });
        default:
            return state;
    }
}

export const evt = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVT}_SUCCESS`:
            const evt = action.payload.data;
            return Object.assign({}, state, {
                isFetching: false,
                data: evt,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/evt.js